import { FC } from 'react';
import { lt, useLocalizeText, useLocalizeCurrency } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack, Typography } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { Amount } from '@mews-commander/data-access';

interface UpdatePriceTextProps {
    highlightedPrice: boolean;
    priceDiff: Amount | undefined | null;
}

export const UpdatePriceText: FC<UpdatePriceTextProps> = ({ priceDiff, highlightedPrice }) => {
    const ltx = useLocalizeText();
    const lc = useLocalizeCurrency();

    const priceElement = priceDiff?.value != null && (
        <>
            {priceDiff.value < 0 ? UnicodeEntity.MinusSign : UnicodeEntity.PlusSign}
            {lc(Math.abs(priceDiff.value), priceDiff.currency)}
        </>
    );

    return (
        <Stack>
            {lt('UpdatePrice')}
            {priceElement && (
                <>
                    {UnicodeEntity.Colon}
                    {UnicodeEntity.NoBreakSpace}

                    {highlightedPrice ? (
                        <Typography textStyle="bodyMediumStrong" as="div">
                            {priceElement}
                        </Typography>
                    ) : (
                        priceElement
                    )}

                    {UnicodeEntity.NoBreakSpace}
                    {ltx({ textKey: TextKey.InTotal }).toLocaleLowerCase()}
                </>
            )}
        </Stack>
    );
};
